<div class="mfa-enroll">
  <!-- Step 1: scan QR + confirm first code -->
  <div *ngIf="step === 'enroll'">
    <p class="mfa-instruction">{{ "mfa.scanInstruction" | translate }}</p>

    <div *ngIf="loading" class="mfa-loading">{{ "mfa.loading" | translate }}</div>

    <div *ngIf="!loading && otpauthUrl" class="enroll-body">
      <div class="qr-frame">
        <qrcode
          [qrdata]="otpauthUrl"
          [width]="240"
          [margin]="4"
          errorCorrectionLevel="M"
        ></qrcode>
      </div>

      <div class="secret-block">
        <span class="secret-label">{{ "mfa.manualEntry" | translate }}</span>
        <code class="secret-value">{{ secret }}</code>
      </div>

      <form [formGroup]="codeForm" class="code-form">
        <mat-form-field appearance="outline" class="code-field">
          <mat-label>{{ "mfa.codeLabel" | translate }}</mat-label>
          <input
            matInput
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
            placeholder="000000"
            formControlName="code"
          />
        </mat-form-field>

        <div *ngIf="error" class="mfa-error">{{ error | translate }}</div>

        <button
          mat-flat-button
          color="primary"
          class="mfa-btn"
          [disabled]="!codeForm.valid || submitting"
          (click)="confirm()"
        >
          {{ "mfa.confirm" | translate }}
        </button>
      </form>
    </div>

    <div *ngIf="!loading && !otpauthUrl && error" class="mfa-error center">
      {{ error | translate }}
    </div>
  </div>

  <!-- Step 2: show one-time backup codes -->
  <div *ngIf="step === 'backup'">
    <h3 class="mfa-subtitle">{{ "mfa.backupTitle" | translate }}</h3>
    <p class="mfa-instruction">{{ "mfa.backupInstruction" | translate }}</p>

    <div class="backup-grid">
      <code class="backup-chip" *ngFor="let code of backupCodes">{{ code }}</code>
    </div>

    <mat-checkbox [(ngModel)]="saved" color="primary" class="saved-check">
      {{ "mfa.savedConfirm" | translate }}
    </mat-checkbox>

    <button
      mat-flat-button
      color="primary"
      class="mfa-btn full"
      [disabled]="!saved"
      (click)="finish()"
    >
      {{ "mfa.finish" | translate }}
    </button>
  </div>
</div>
